import { CSSResultGroup, html, css, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import componentStyles from './ghs-disclosure.css.lit';

/**
 * The Disclosure component.
 * @element ghs-disclosure
 */
@customElement('ghs-disclosure')
export class GhsDisclosure extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, css``];
  @property({
    type: Boolean,
    reflect: true,
    attribute: 'separator',
  })
  separator = false;

  @property()
  isClosed: boolean;

  @property()
  isWideViewport: boolean;

  @property()
  stateBeforeResizingViewport: boolean;

  mq = window.matchMedia('(min-width: 768px)');

  private _verifyMinWidthPassed = (event: MediaQueryListEvent) => {
    if (event.matches) {
      this.isClosed = false;
      this.isWideViewport = true;
    } else {
      this.isWideViewport = false;
      this.isClosed = this.stateBeforeResizingViewport;
    }
  };

  constructor() {
    super();
    this.isWideViewport = this.mq.matches;
    this.isClosed = !this.isWideViewport;
    this.stateBeforeResizingViewport = !!this.isWideViewport || this.isClosed;
    this.separator = false;
  }

  connectedCallback() {
    super.connectedCallback();
    this.mq.addEventListener('change', this._verifyMinWidthPassed);
  }

  toggleMenu() {
    this.isClosed = !this.isClosed;
    this.stateBeforeResizingViewport = this.isClosed;
  }

  render(): TemplateResult {
    return html`
      <div class="ghs-disclosure">
        <button
          @click="${this.toggleMenu}"
          class="${this.isWideViewport ? 'hidden' : ''}"
          aria-expanded="${this.isClosed ? 'false' : 'true'}"
        >
          ${this.isClosed ? 'Filter results' : 'Collapse filters'}
          <ghs-icon
            name="${this.isClosed ? 'filter-list' : 'close'}"
            mobile-size="${this.isClosed ? '32px' : '18px'}"
            class="${this.isClosed ? 'menu-icon' : 'close-icon'}"
          />
        </button>
        ${this.isWideViewport && this.separator
          ? html` <hr class="separator" />`
          : ''}
        <div class="${this.isClosed ? 'hidden' : ''}">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
